import React, { useState, useEffect, forwardRef } from 'react';
import { TextField, Button, Typography, Container, CssBaseline, Link, Snackbar, Box, Autocomplete } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import axios from 'axios';
import api from 'services/api';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const NovoCadastro = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [ufs, setUfs] = useState([]);
  const [selectedUF, setSelectedUF] = useState('');
  const [municipios, setMunicipios] = useState([]);
  const [selectedMunicipio, setSelectedMunicipio] = useState('');
  const [nomeMunicipio, setNomeMunicipio] = useState(''); // Novo estado para o nome do município
  const [error, setError] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    carregarUFs();
  }, []);

  const carregarUFs = () => {
    axios.get('https://contatos.cnm.org.br/api/list/estados')
      .then(response => {
        setUfs(response.data);
      })
      .catch(error => {
        console.error('Erro ao carregar UFs:', error);
      });
  };

  const carregarMunicipios = (siglaUF) => {
    axios.get(`https://contatos.cnm.org.br/api/list/municipios/${siglaUF}`)
      .then(response => {
        setMunicipios(response.data);
      })
      .catch(error => {
        console.error('Erro ao carregar municípios:', error);
      });
  };

  const handleUFChange = (e, value) => {
    if (value) {
      setSelectedUF(value.sigla);
      carregarMunicipios(value.sigla);
    }
  };

  const handleMunicipioChange = (e, value) => {
    if (value) {
      setSelectedMunicipio(value.ibge);       // Código IBGE
      setNomeMunicipio(value.descricao);      // Nome do município
    }
  };

  const handleCadastro = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('cadastro', {
        nome,
        email,
        password,
        perfil: '1',
        status: 'ativo',
        uf: selectedUF,
        ibge: selectedMunicipio.toString(),  // Código IBGE
        municipio: nomeMunicipio             // Nome do município
      });
      console.log(response.data);
      setNome('');
      setEmail('');
      setPassword('');
      setSelectedUF('');
      setSelectedMunicipio('');
      setNomeMunicipio('');
      setSnackbarOpen(true);
    } catch (err) {
      setError('Erro ao cadastrar. Por favor, tente novamente.');
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container component="main" maxWidth="xs" sx={{ height: '69vh' }}>
      <CssBaseline />
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          Novo Cadastro
        </Typography>
        {error && <Typography variant="subtitle2" color="error">{error}</Typography>}
        <Box component="form" onSubmit={handleCadastro} sx={{ mt: 1, width: '100%' }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="nome"
            label="Nome"
            name="nome"
            autoComplete="name"
            autoFocus
            aria-label="Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            aria-label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="new-password"
            aria-label="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          
          {/* Autocomplete para selecionar UF */}
          <Autocomplete
            options={ufs}
            getOptionLabel={(option) => `${option.descricao} - ${option.sigla}`}
            value={ufs.find((uf) => uf.sigla === selectedUF) || null}
            onChange={handleUFChange}
            renderInput={(params) => (
              <TextField {...params} label="Selecione o seu estado" variant="outlined" required fullWidth aria-label="UF" />
            )}
          />

          {/* Autocomplete para selecionar Município */}
          <Autocomplete
            options={municipios}
            getOptionLabel={(option) => option.descricao}
            value={municipios.find((municipio) => municipio.ibge === selectedMunicipio) || null}
            onChange={handleMunicipioChange}
            renderInput={(params) => (
              <TextField {...params} label="Selecione seu município" variant="outlined" required fullWidth aria-label="Município" />
            )}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
            aria-label="Cadastrar"
          >
            Cadastrar
          </Button>
          <Typography align="center">
            <Link href="/login" variant="body2" aria-label="Já tem uma conta? Faça login">
              Já tem uma conta? Faça login
            </Link>
          </Typography>
        </Box>
      </Box>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar} role="alert">
        <Alert onClose={handleCloseSnackbar} severity="success">
          Cadastro realizado com sucesso! Sua solicitação será analisada.
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default NovoCadastro;
